import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fa2f1a7&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa2f1a7')) {
      api.createRecord('4fa2f1a7', component.options)
    } else {
      api.reload('4fa2f1a7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fa2f1a7&", function () {
      api.rerender('4fa2f1a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/email-log/index.vue"
export default component.exports